import React from 'react';

const List = ({ text }) => {
	if ( !text ) return null;
	
	const segments = text.split( "\n" ).map( (segment, index) => {
		if ( segment ) {
			return <li key={index}>{segment}</li>;
		} else {
			return <li key={index} aria-hidden="true" style={{visibility: 'hidden'}}></li>
		}
	});
	return <ul className="List">{segments}</ul>
}

export default List;


// WEBPACK FOOTER //
// ./src/components/Pages/About/List.jsx